import { type NodeRenderer } from '@contentful/rich-text-react-renderer'
import Media from '@ui/media/media'
import React from 'react'

export const inlineImage: NodeRenderer = (node) => {
  const {
    data: { url, alt, title },
  } = node

  return <Media alt={alt} title={title} url={url} />
}
